// @flow
import * as React from 'react'
import './styles.scss'

type Props = {
  clickHandler: () => void
}

export function RatingExplanationButton({ clickHandler }: Props) {
  return (
    <button
      className='ui large basic button rating-explanation'
      onClick={clickHandler}
    >
      <i className='info circle icon' />
      So wurde bewertet
      <i className='right chevron icon' />
    </button>
  )
}
